<template>
  <div class="user-permissions-card">
    <data-table
      v-if="users"
      :headers="fields"
      :items="users"
      item-key="ref"
      class="user-permissions-card__table"
      :loaded="loaded"
    >
      <template v-slot:[`item.flags`]="{ item }">
        <v-chip :color="chipColour" small class="mr-2"
          >Build
          <v-checkbox
            :readonly="item.readonly"
            color="purple"
            @change="setBuild(item, $event)"
            background-color="rgba(255, 255, 255, 0)"
            :input-value="item.flags.build"
            class="ma-0"
          ></v-checkbox>
        </v-chip>
        <v-chip :color="chipColour" small
          >Admin
          <v-checkbox
            :readonly="item.readonly"
            color="purple"
            @change="setAdmin(item, $event)"
            :input-value="item.flags.admin"
          ></v-checkbox
        ></v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn v-if="item.email != user_email" icon @click="userToDelete = item.email; deleteUser = true"><apio-icon
              lightModeColour="black"
              darkModeColour="white"
              name="ui-trash"
            /></v-btn>
      </template>
      <template v-slot:[`footer`] />
    </data-table>
    <PromptModal @callback="removeUser(userToDelete)" :show.sync="deleteUser"
      title="Removing User" :question="'Are you sure you want to remove '+userToDelete+' from the organisation?'" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    organisationHash: {
      type: String,
      default: "",
    },
    organisationName: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      users: (state) => state.users.users,
      user_email: (state) => state.auth.user_email,
    }),
    chipColour() {
      return this.isDarkMode ? 'apioshade2' : 'apioshade5';
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode
    },
  },
  components: {
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
    PromptModal: () => import("@/components/PromptModal.vue"),
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    setBuild(item,val) {
      this.$store.dispatch("setRole", {
        u: encodeURI(item.email),
        c: this.$route.params.id,
        a: item.flags?.admin,
        b: val
      })
      item.flags.build = val
    },
    setAdmin(item,val) {
      this.$store.dispatch("setRole", {
        u: encodeURI(item.email),
        c: this.$route.params.id,
        a: val,
        b: item.flags?.build
      })
      item.flags.admin = val
    },
    removeUser(email) {
      if (this.organisationHash != "") {
        this.$store.dispatch("removeUser", {
          email: email,
          client: this.$route.params.id,
        })
      }
    },
  },
  data() {
    return {
      loaded: false,
      userToDelete: '',
      deleteUser: false,
      headers: [
        {
          text: "Email address",
        },
        { text: "ID" },
        { text: "Date / time" },
      ],
      fields: [
        {
          value: "email",
          text: "Email",
        },
        {
          value: "fullname",
          text: "Full Name",
        },
        {
          value: "flags",
          text: "Permissions & Access",
        },
        {
          value: "actions",
          text: "Actions",
        }
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

::v-deep .v-input__control {
  height: 24px;
  background-color: var(--apio-shade-5) !important;
}

::v-deep .user-permissions-card {
  &__table {
    max-width: 940px;
    margin: 16px 0;
    padding: 0 !important;
  }
}
</style>

